import type { ReactNode } from 'react'

import ButtonWrapper from './button-wrapper'

type PrimaryButtonProps = {
  children: ReactNode
  bgColor?: string
  classNameButton?: string
  classNameText?: string
  type?: any // this type will change :(
  onClick?: () => void
  isLoading?: boolean
  disabled?: boolean
}

export default function PrimaryButton({
  bgColor,
  classNameButton,
  classNameText,
  type,
  disabled = false,
  onClick,
  children,
  isLoading,
}: PrimaryButtonProps) {
  return (
    <ButtonWrapper
      isLoading={isLoading}
      disabled={disabled}
      className={classNameButton}
    >
      <button
        onClick={onClick}
        type={type}
        className={`border border-solid rounded-lg ${
          bgColor === '100' ? 'border-primary-100 bg-primary-100' : ''
        } ${bgColor === '600' ? 'border-primary-600 bg-primary-600' : ''} ${
          classNameButton ? classNameButton : 'h-11'
        }`}
      >
        <span
          className={`font-medium text-base  ${
            bgColor === '100' ? 'text-primary-600' : ''
          } ${bgColor === '600' ? 'text-white-100' : ''} ${classNameText}`}
        >
          {children}
        </span>
      </button>
    </ButtonWrapper>
  )
}
